/* eslint-disable max-len */
import axios from 'axios';

const loadAudienceNavigation = loadConfig => {
    const {
        navigationApiUrl,
        navigationAudienceId,
        authToken,
        countryCode,
        continentCode,
        regionCode,
    } = loadConfig;

    const queryParams = {
        ...(continentCode && { continentCode }),
        ...(countryCode && { countryCode }),
        ...(regionCode && { regionCode }),
    };
    return axios.get(`${navigationApiUrl}/v1/audience/${navigationAudienceId}/navbar`,
        {
            headers: {
                ...(authToken && { 'Member-Authorization-Token': authToken }),
            },
            params: queryParams, // Pass query parameters here
        }).then(res => (res.data && res.data.data))
        .catch(() => ({}));
};

export default loadAudienceNavigation;
